import wrapInObserver from '../../wrapInObserver';
import AvgPriceBanner from './AvgPriceBanner';
import AvgPriceBannerMobile from './AvgPriceBannerMobile';
import logger from '../../../logger';
import generatedHooks from '../../../hooks/generatedHooks';

import { makeAvgPriceUrl } from '../../../utils/urlProvider';
import BannerStore from '../../../stores/bannerStore';

const { useBannerStore } = generatedHooks;

const mapProps = () => {
  try {
    const bannerStore = useBannerStore(store => store);

    return {
      avgPriceUrl: makeAvgPriceUrl(),
      closeBanner: bannerStore.putAvgPriceBannerViewedFlag,
      imageUrl: bannerStore.banners[BannerStore.BANNER_TYPES.AVG_PRICE].imageUrl,
    };
  } catch (error) {
    logger.error(error, { sentryMessage: 'Error while rendering AvgPriceBanner' });
    return {};
  }
};

export default wrapInObserver(AvgPriceBanner, mapProps, AvgPriceBannerMobile);
